export function setActive(items, current, perPage) {
	items.forEach((item, i) => {
		item.classList.toggle('active', i === (current / perPage));
	});
}
